import React from "react";
import ContactsIcon from "../../assets/icons/contact_edit.svg2";
import BillingOverviewIcon from "../../assets/icons/billing_overview.svg2";
import WhiteButton from "../Common/WhiteButton";
import Subheading from "../Common/Subheading";
import MyIcon from "../Common/MyIcon";
import HelpButton from "../HelpContent/HelpButton";
import { Col, Row } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle } from "@fortawesome/free-solid-svg-icons";
import MyCollapse from "../Common/MyCollapse";
import NewFeature from "../Builder/Components/NewFeature";

export default function BillingOverview() {
  return (
    <div>
      <NewFeature>
        <div className="d-flex justify-content-between align-items-center">
          <Subheading
            Icon={BillingOverviewIcon}
            heading="Product Overview"
            subheading="View the List of Available Boomerang Products"
          />
          <WhiteButton
            as="RRLink"
            icon={ContactsIcon}
            heading="Boomerang UI Sales"
          />
        </div>
        <Row xs={1} xl={2} className="my-3">
          <Col>
            <div className="bg-purple-gradient-darker-reverse rounded-4 p-3  ">
              <MyCollapse
                heading={
                  <>
                    <h5 className=" d-flex align-items-center">
                      <MyIcon Icon={BillingOverviewIcon} className="me-2" />
                      <span className="ms-2">
                        <span className="fw-bold me-2"> Products:</span>
                        <HelpButton helpKey="billing-overview-products" />
                        <div className="small text-secondary">
                          View your Boomerang products
                        </div>
                      </span>
                    </h5>
                  </>
                }
              >
                <div>
                  <hr className="my-3 text-secondary" />
                  <div className="row">
                    <div className="col-6"></div>
                    <div className="col-6"></div>
                  </div>
                </div>
              </MyCollapse>
            </div>
          </Col>
          <Col>
            <div className="bg-purple-gradient-darker-reverse rounded-4 p-3 ">
              <MyCollapse
                heading={
                  <>
                    <h5 className=" d-flex align-items-center">
                      <MyIcon Icon={BillingOverviewIcon} className="me-2" />
                      <span className="ms-2">
                        <span className="fw-bold me-2"> Account bolt-ons:</span>
                        <HelpButton helpKey="billing-overview-account-bolt-ons" />
                        <div className="small text-secondary">
                          Tailor your account further with our premium addons
                        </div>
                      </span>
                    </h5>
                  </>
                }
              >
                <hr className="my-3 text-secondary" />
                <div className="row">
                  <div className="col-6"></div>
                  <div className="col-6"></div>
                </div>
              </MyCollapse>
            </div>
          </Col>
        </Row>
        <hr className="my-5 text-secondary" />
        <div className="d-flex justify-content-end">
          <button
            type="submit"
            className="btn btn-colored-reverse rounded-pill fw-bold "
          >
            <FontAwesomeIcon icon={faCheckCircle} className="me-2" />
            Continue to Payment
          </button>
        </div>
      </NewFeature>
    </div>
  );
}
